import { getAppliedStyle, inputStyles } from "../styles";
import { useDropzone } from "./useDropzone";
import { allFilesAccepted } from "../utils";

export const useDropzoneStyles = props => {
  const {
    accept,
    acceptClassName,
    activeClassName,
    disabled,
    disabledClassName,
    inputProps,
    multiple,
    rejectClassName,
    ...rest
  } = props;

  const { draggedFiles, isDragActive } = useDropzone(props);

  let {
    acceptStyle,
    activeStyle,
    className = "",
    disabledStyle,
    rejectStyle,
    style,
    ...divProps
  } = rest;

  const filesCount = draggedFiles.length;
  const isMultipleAllowed = multiple || filesCount <= 1;
  const isDragAccept = filesCount > 0 && allFilesAccepted(draggedFiles, accept);
  const isDragReject = filesCount > 0 && (!isDragAccept || !isMultipleAllowed);
  const noStyles =
    !className && !style && !activeStyle && !acceptStyle && !rejectStyle && !disabledStyle;

  if (isDragActive && activeClassName) {
    className += " " + activeClassName;
  }
  if (isDragAccept && acceptClassName) {
    className += " " + acceptClassName;
  }
  if (isDragReject && rejectClassName) {
    className += " " + rejectClassName;
  }
  if (disabled && disabledClassName) {
    className += " " + disabledClassName;
  }

  const appliedStyle = getAppliedStyle({
    style,
    noStyles,
    activeStyle,
    acceptStyle,
    rejectStyle,
    disabledStyle,
    isDragActive,
    isDragAccept,
    isDragReject,
    disabled,
  });

  return { className, appliedStyle, divProps, isDragAccept, isDragReject };
};



// WEBPACK FOOTER //
// ./components/common/file-uploader/hooks/useDropzoneStyles.js